import { CreateDepartmentInput, UpdateDepartmentInput } from './department.interface';

export class GetDepartments {
    static readonly type = '[departments] all dept';
}

export class CreateDepartment {
    static readonly type = '[departments] create dept';
    constructor(public input: CreateDepartmentInput) {}
}

export class UpdateDepartment {
    static readonly type = '[departments] update dept';
    constructor(public input: UpdateDepartmentInput) {}
}

export class DeleteDepartment {
    static readonly type = '[departments] delete dept';
    constructor(public id: string) {}
}
